import React from 'react'
import {
  Grid,
  MenuItem,
  IconButton,
  Button,
  CircularProgress,
  Select,
  TextField
} from '@mui/material'
import { RotateLeft } from '@mui/icons-material'

interface CourierSearchProps {
  searchState: { selected: string; value: string }
  setSearchState: React.Dispatch<
    React.SetStateAction<{
      selected: string
      value: string
    }>
  >
  onSearchClick: () => void
}

export const CourierSearch: React.FC<CourierSearchProps> = ({
  onSearchClick,
  searchState,
  setSearchState
}) => {
  return (
    <Grid container spacing={2} direction={'row'}>
      <Grid item xs={12} sm={6} md={3}>
        <Select
          variant='outlined'
          labelId={`select-label-${searchState.selected}`}
          value={searchState.selected}
          onChange={(event) =>
            setSearchState((prev) => ({
              ...prev,
              selected: event.target.value as string
            }))
          }
          label='Seleccione una opción...'
          fullWidth
        >
          <MenuItem value='0'>Seleccione una opción...</MenuItem>
          <MenuItem value='courierName'>Courier</MenuItem>
          <MenuItem value='courierServiceName'>Servicio de Courier</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          label={'Buscar'}
          fullWidth
          variant='outlined'
          value={searchState.value}
          onChange={(e) =>
            setSearchState((prev) => ({ ...prev, value: e.target.value }))
          }
        />
      </Grid>

      <Grid item xs={4} sm={6} md={2} container>
        <IconButton
          onClick={() => setSearchState({ selected: '0', value: '' })}
        >
          <RotateLeft />
        </IconButton>
      </Grid>
      <Grid
        item
        xs={8}
        sm={6}
        md={3}
        container
        alignItems='center'
        justifyContent='flex-end'
      >
        <Button
          variant='contained'
          color='primary'
          onClick={onSearchClick}
          endIcon={status && <CircularProgress size={'small'} />}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  )
}
